import styles from './style.module.scss';
import { ReactElement } from 'react';
import DeviceBadge from '@/globalComponents/deviceBadge';

export type detailProp = {
  status: boolean;
  label: ReactElement;
};

export type StatusTrackingProp = {
  classNames?: string;
  details: detailProp[];
};

const icon = (status: boolean) => {
  return <div data-status={status} className={styles.statusIcon}></div>;
};

const StatusTracking = (props: StatusTrackingProp) => {
  const { details, classNames } = props;

  return (
    <div className={`h-fit relative w-full ${classNames}`}>
      <div className={`relative flex flex-col w-full ${styles.statusContainer}`}>
        {details.map((detail, index) => {
          const status = detail.status;
          const containerClassNames = `font-semibold text-base flex gap-s5 h-fit`;
          return (
            <div
              className={`${styles.status} ${containerClassNames}`}
              key={`${detail.status}` + index}
            >
              <div className="flex flex-col justify-start content-center items-center">
                <div
                  data-status={status}
                  className={`${styles.statusIconBorder} flex-shrink-0 self-start`}
                >
                  {icon(detail.status)}
                </div>
                {index !== details.length - 1 && (
                  <div
                    className={`h-full w-px border-transparent opacity-10 ${styles.dashedBorder}`}
                  />
                )}
              </div>
              <div
                data-status={status}
                className={`flex-1 ${!status ? 'text-[#BDBDBD]' : 'text-[#0D152A'} pb-8 self-start`}
              >
                {detail.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StatusTracking;
